import { CycleUtils } from '@wix/package-picker-shared';
import { dynamicLoadUpgradeQueries } from '../utils';
export const isCycleAvailableQueryFn = async _ref => {
  let {
    httpClient,
    request
  } = _ref;
  if (!request.productId) {
    return {
      isCycleAvailable: false
    };
  }
  const {
    fetchUpgradableCycles
  } = await dynamicLoadUpgradeQueries(httpClient);
  const availableCyclesByProductId = await fetchUpgradableCycles({});
  const availableCycles = availableCyclesByProductId == null ? void 0 : availableCyclesByProductId[request.productId];
  if (!availableCycles) {
    return {
      isCycleAvailable: false
    };
  }
  const isCycleAvailable = availableCycles.some(c => {
    return CycleUtils.isCycleEqual(c, request.cycle);
  });
  return {
    isCycleAvailable
  };
};
//# sourceMappingURL=isCycleAvailable.query.js.map